module.exports = __webpack_public_path__ + "media/images/policies/redirect_popup/creditcard-company-2-177fafb01836fc632bcb973cf82eaff9.png";